const evaluateWaitMessage = ({ args }) => {
  const delay = args?.delay || 1000;
  const isSingular = delay < 1000 ? false : delay / 1000 === 1;
  const label = delay < 1000 ? `${delay} milliseconds` : `${delay / 1000} second${isSingular ? '' : 's'}`;
  return `Wait for ${label}`;
};

export default evaluateWaitMessage;
